import React from 'react';
import Grid from '@material-ui/core/Grid';
import BrowseListItemSkeleton from './BrowseListItemSkeleton';

export interface BrowseListSkeletonProps {
    products: any[];
}

const BrowseListSkeleton = ({products = []}) => (
    <Grid container spacing={2}>
        {products.map((game, i) => (
            <Grid key={`game-placeholder-${i}`} item xl={2} md={3} xs={6}>
                <BrowseListItemSkeleton />
            </Grid>
        ))}
    </Grid>
);

export default React.memo(BrowseListSkeleton);
